import imgNew1 from "../assets/Images/KT-off-k7/nang-luong-goc.jpg";
import imgNew2 from "../assets/Images/KT-off-k7/pp-voi-chinh-minh.jpg";
import imgNew3 from "../assets/Images/KT-offk6/benefit/boc_mac_cho_con.jpg";
import imgNew4 from "../assets/Images/KT-off-k7/giai-phong-con-tuc-gian.jpg";
import imgNew5 from "../assets/Images/KT-off-k7/modeling.jpg";
import imgNew6 from "../assets/Images/KT-off-k7/niem-tin-gioi-han.jpg";

const listEvent = document.querySelectorAll(".item-benefit");
const imgEvent = document.getElementById("image_event");

const imageSources = [imgNew1, imgNew2, imgNew3, imgNew4, imgNew5, imgNew6];

listEvent.forEach((item, index) => {
	item.addEventListener("mouseenter", () => {
		if (imgEvent && imageSources[index]) {
			imgEvent.src = imageSources[index];
		}
	});
});
